import { nextTick } from 'vue'
import { havePermission } from '@/utils'
import store from "@/store";
export default {
  install: function (app) {
    /**
     * @description: 权限控制指令
     * @param {*}
     * @return {*}
     * @author: gumingchen
     */
    app.directive('hasPermi', {
      mounted: (el, binding, vnode) => {
        const { value } = binding
        const all_permission = '*:*:*'
        const permissions = store.state && store.state.common.permissions
        if (value && value instanceof Array && value.length > 0) {
          const permissionFlag = value
          const hasPermissions = permissions.some((permission) => {
            return (
              all_permission === permission || permissionFlag.includes(permission)
            )
          })
          if (!hasPermissions) {
            //todo 去掉权限过滤
            el.parentNode && el.parentNode.removeChild(el)
          }
        } else {
          // console.log(`请设置操作权限标签值`)
        }


        // const permission = binding.value
        // const result =permission// havePermission(permission)
        // const tagName = el.localName
        // console.log(result,'result==')
        // if (!result) {
        //   switch (tagName) {
        //     case 'button': // 按钮权限控制-删除tag
        //       el.remove()
        //       break
        //     case 'div': // element-plus switch 组件权限控制
        //       if (vnode.props && vnode.props.class && vnode.props.class.includes('el-switch')) {
        //         nextTick(() => {
        //           el.className += ' is-disabled' // 设置禁用样式
        //           const tag = el.cloneNode(true) // 深拷贝节点以解除绑定事件
        //           const parent = el.parentNode
        //           el.remove()
        //           parent.append(tag)
        //         })
        //       }
        //       break
        //   }
        // }
      }
    })

    /**
     * @description: 表单防止重复提交指令
     * @param {*}
     * @return {*}
     * @author: gumingchen
     */
    app.directive('repeat', {
      mounted(el, binding) {
        el.addEventListener('click', () => {
          if (!el.disabled) {
            el.disabled = true
            setTimeout(() => {
              el.disabled = false
            }, binding.value || 2000)
          }
        })
      }
    })
  }
}


